"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialContractUpdate = exports.CommercialContractCreate = exports.CommercialContractQuery = exports.CommercialContract = exports.CommercialContractTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const commercial_contract_shared_1 = require("./commercial-contract-shared");
exports.CommercialContractTransport = commercial_contract_shared_1.CommercialContractSharedFields;
exports.CommercialContract = exports.CommercialContractTransport;
exports.CommercialContractQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([common_1.BaseQuery, commercial_contract_shared_1.CommercialContractSharedQuery]));
exports.CommercialContractCreate = commercial_contract_shared_1.CommercialContractSharedCreateFields;
exports.CommercialContractUpdate = commercial_contract_shared_1.CommercialContractSharedUpdateFields;
//# sourceMappingURL=CommercialContract.js.map